var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('a-link',{staticClass:"ci-commit-tag-link",attrs:{"to":_vm.tagUrl,"open-in-new-tab":""}},[_vm._v("\n  "+_vm._s(_vm.tagVersion)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }